import React from 'react';

import { TicketGroupsProvider } from './TicketGroupsContext';
import { TicketGroupEditProvider } from './TicketGroupEditContext';

import TicketGroupsList from './components/TicketGroupsList';
import AddTicketGroupDialog from './components/AddTicketGroupDialog';

const EventTicketTypesForm = () => {
  return (
    <TicketGroupsProvider>
      <TicketGroupEditProvider>
        <TicketGroupsList />

        <AddTicketGroupDialog />
      </TicketGroupEditProvider>
    </TicketGroupsProvider>
  );
};

export default EventTicketTypesForm;
